// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonLaserPointerPlain_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.5732 4.34674L18.866 2.10744L17.134 1.10744L15.8411 3.34681L15.1718 0.849121L13.24 1.36676L13.9092 3.86444L11.6699 2.57155L10.6699 4.3036L12.9089 5.5963L10.4116 6.26546L10.9292 8.19732L13.3583 7.54643L10.5904 12.3406L12.3225 13.3406L15.1404 8.45983L15.828 11.0259L17.7598 10.5083L17.0906 8.01059L19.3301 9.3036L20.3301 7.57155L18.0907 6.27862L20.5886 5.60932L20.0709 3.67747L17.5732 4.34674Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.35834 20.8669L8.85834 11.3406L14.0545 14.3406L8.55449 23.8669L3.35834 20.8669ZM11.366 15.0978L9.63395 14.0978L8.63395 15.8299L10.366 16.8299L11.366 15.0978Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonLaserPointerPlain is a generated icon component.
 */
let IconCommonLaserPointerPlain = IconCommonLaserPointerPlain_1 = class IconCommonLaserPointerPlain extends IconBaseElement {
    render() {
        return html `${IconCommonLaserPointerPlain_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonLaserPointerPlain.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonLaserPointerPlain = IconCommonLaserPointerPlain_1 = __decorate([
    customElement('zui-icon-common-laser-pointer-plain')
], IconCommonLaserPointerPlain);
export { IconCommonLaserPointerPlain };
